import EditorPrefixCode from './EditorPrefixCode';

export default EditorPrefixCode;
